import { ApiError } from "../api/fastapi";

// The backend's own sentence for a request it refused, if it sent one. A 5xx
// detail can carry internals, so only a 4xx's is shown to a user.
export function refusalDetail(error: unknown): string | null {
  if (error instanceof ApiError && error.status < 500 && error.detail) {
    return error.detail;
  }
  return null;
}
